const {
  apiFetch,
  url: {
    addQueryArgs,
  },
} = wp;

const searchAPI = {
  /**
   * Search videos.
   *
   * This returns videos in template item format which is what we want.
   *
   * @param {String} query Search query.
   * @param {Number} page
   * @param {Number} perPage
   * @returns {Promise}
   */
  searchVideos(query, page = 1, perPage = 12) {
    const splitQuery = query.split(' ').join('+');

    const path = addQueryArgs(`/nbc/v1/template/search/${splitQuery}`, {
      page,
      per_page: perPage,
      post_type: 'video',
    });

    return apiFetch({ path });
  },
};

export default searchAPI;
